/**
 * Since this value is hardcoded on the backend and used without any constants,
 * we can hardcode it on frontend as well
 */
export const BASE_URL = '/app';
